import React from 'react';
import { Zap } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="bg-white py-20 px-4" data-id="element-260">
      <div className="max-w-4xl mx-auto" data-id="element-261">
        <div className="text-center mb-12" data-id="element-262">
          <p className="text-xl md:text-2xl text-chocolate-800 mb-4" data-id="element-263">
            Hay una razón científica por la que tu cerebro pide dulce todos los
            días.
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-chocolate-900" data-id="element-264">
            Se llama{' '}
            <span className="text-gold-500 bg-gold-500/10 px-2 py-1 rounded" data-id="element-265">
              DÉFICIT PROTEICO FUNCIONAL
            </span>
            .
          </h2>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-chocolate-800/5 mb-12" data-id="element-266">
          <p className="text-lg md:text-xl text-chocolate-800 leading-relaxed mb-6" data-id="element-267">
            Cuando no recibís suficiente proteína en el momento correcto... tu
            cerebro activa una señal de emergencia:{' '}
            <span className="font-bold italic" data-id="element-268">"Dame glucosa. Ahora."</span>
          </p>
          <p className="text-lg md:text-xl text-chocolate-800 leading-relaxed font-medium" data-id="element-269">
            No hay dieta ni voluntad que apague esa señal. Solo la proteína
            correcta en el momento correcto.
          </p>
        </div>

        <div className="bg-chocolate-900 text-chocolate-50 p-8 md:p-12 rounded-3xl shadow-2xl relative overflow-hidden" data-id="element-270">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/10 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-271"></div>

          <div className="relative z-10" data-id="element-272">
            <div className="flex items-center space-x-3 mb-6" data-id="element-273">
              <Zap className="w-8 h-8 text-gold-400" data-id="element-274" />
              <h3 className="text-3xl font-bold text-gold-400" data-id="element-275">EL ANTÍDOTO</h3>
            </div>

            <p className="text-xl mb-8" data-id="element-276">
              En lugar de pelear contra ese mecanismo... lo hackeamos.
              <br data-id="element-277" />
              <br data-id="element-278" />
              <span className="font-bold text-2xl text-white" data-id="element-279">
                Dulce real + fórmula proteica exacta = antojo apagado en 3
                minutos.
              </span>
            </p>

            <ul className="space-y-4 text-lg md:text-xl" data-id="element-280">
              <li className="flex items-center space-x-3" data-id="element-281">
                <span className="text-solution font-bold" data-id="element-282">→</span>
                <span data-id="element-283">Disfrutás el dulce de verdad.</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-284">
                <span className="text-solution font-bold" data-id="element-285">→</span>
                <span data-id="element-286">Tu cerebro registra saciedad real.</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-287">
                <span className="text-solution font-bold" data-id="element-288">→</span>
                <span data-id="element-289">El ciclo de culpa se rompe.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}